import Loading from 'components/common/loading/Loading'
import { useLoading } from 'components/common/loading/useLoading'
import OsmMapPreview from 'components/common/OsmMapPreview'
import { WizardStepProperties } from 'components/types'
import { AddressData, Location } from 'newTypes/location'
import { useEffect, useState } from 'react'
import { GeoPoint } from 'types/osmAddress'

import AddressAutocomplete from './AddressAutocompleteInput'

const LocationInput = ({
  name,
  label,
  value,
  icon,
  required,
  isFirstInput,
  onChange,
  setIsValid,
}: WizardStepProperties) => {
  const [selectedLocation, setSelectedLocation] = useState<GeoPoint | null>(null)
  const [mapHeight, setMapHeight] = useState('250px')
  const { isLoading, setLoading } = useLoading()

  useEffect(() => {
    setLoading(true)
    const updateMapHeight = () => {
      const width = Math.min(window.innerWidth, 300)
      setMapHeight(`${width}px`)
    }

    updateMapHeight()
    window.addEventListener('resize', updateMapHeight)
    setLoading(false)

    return () => {
      window.removeEventListener('resize', updateMapHeight)
    }
  }, [setLoading])

  useEffect(() => {
    const addr = value as AddressData | null
    if (addr?.location?.lat != null && addr?.location?.lng != null) {
      setSelectedLocation({ lat: addr.location.lat, lng: addr.location.lng })
    }
  }, [value])

  useEffect(() => {
    if (required && !selectedLocation) {
      setIsValid?.(false)
    } else {
      setIsValid?.(true)
    }
  }, [selectedLocation, required, setIsValid])

  const handleChange = (e: AddressData | null) => {
    if (e?.location) {
      setSelectedLocation(e.location)
    } else {
      setSelectedLocation(null)
    }

    const parsedLocation: Location = {
      city: e?.city ?? '',
      country: e?.country ?? '',
      door_number: e?.door_number ?? '',
      formatted_address: e?.formatted_address ?? '',
      geometry: e?.geometry ? JSON.stringify(e.geometry) : '',
      location: e?.location ? JSON.stringify(e.location) : '',
      number: e?.number ?? '',
      province: e?.province ?? '',
      street: e?.street ?? '',
      zip_code: e?.zip_code ?? '',
    }

    onChange({
      name,
      type: 'location',
      value: parsedLocation,
    })
  }

  return isLoading ? (
    <Loading />
  ) : (
    <div className="p-4">
      <AddressAutocomplete
        name={name}
        label={label}
        value={value as AddressData}
        showIcon={!!icon}
        isFirstInput={!!isFirstInput}
        onPlaceSelect={handleChange}
      />
      <div className="mt-3 w-full max-h-full relative transform transition-opacity duration-300 ease-in-out">
        <OsmMapPreview location={selectedLocation} height={mapHeight} />
      </div>
    </div>
  )
}

export default LocationInput
